module.exports = __webpack_public_path__ + "img/vet-pass.323a2d96.svg";